<template>
    <section class="page-splash page">
        <div class="page__content">
            <img class="page-splash__logo" src="../../assets/images/logo.png">
            <div class="container">
                <div class="row">
                    <div class="col-12-sm">
                        <p>Er zijn ruim 50.000 hybride docenten in Nederland. Zij combineren het docentschap met een andere baan, binnen of buiten het onderwijs. Lijkt jou dat ook wat? Vul dan deze tool in en krijg een beeld van hoe een hybride carrière er voor jou uit kan zien!</p>
                        <p class="page-splash__meer-uitleg">Wil je eerst meer uitleg over hybride docenten?<br/>
                            Klik dan <span v-on:click="uitlegHandler" class="page-splash__hier-btn">hier</span></p>
                    </div>
                </div>
            </div>
            <div class="page-splash__scroll-hint">
                <!--<div class="page-splash__main-icon">-->
                    <!--<div class="page-splash__main-icon-img"></div>-->
                <!--</div>-->

                <page-next-button v-on:click="nextHandler"></page-next-button>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";
    .page-splash__logo
        width 200px

    .page-splash__description
        margin 30px 0

    .page-splash__meer-uitleg
        font-size .8em
        border-left 1px solid
        border-right 1px solid
        padding 15px
        margin-top 30px

    .page-splash__main-icon
        border-radius 50%
        padding 20px
        background-color #fff
        display inline-block

    .page-splash__main-icon-img
        position relative
        top 5px
        background-image url("../../assets/images/hybride-man-150.png")
        background-size contain
        background-repeat no-repeat
        background-position center
        padding 10px
        width 100px
        height 100px

    .page-splash__scroll-message
        font-family Helvetica
        font-size .8em
        display block

    .page-splash__hier-btn
        cursor pointer
        text-decoration underline

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');

    import page from './page';

    export default {
        mixins: [page],
        mounted2() {
            new ScrollMagic.Scene( {
                    triggerElement: '.page-splash'
                })
                .setPin('.page-splash')
                .addTo(this.scroller);
        },
        methods: {
            uitlegHandler() {
                this.$emit('uitleg');
            },
            nextHandler() {
                this.$emit('next');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// page-splash.vue?606ebef5